import { Alert, AlertIcon, VStack, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { useSnapshot } from 'valtio';
import { quickReferralModalState } from '../../tenantState/QuickReferralState';

export function ParticipantExistsAlert() {
  const snap = useSnapshot(quickReferralModalState);

  const showAlert = snap.hasActiveAccreditedCourse && snap.courseData.accredited;

  if (!showAlert) {
    return null;
  }

  return (
    <Alert status="warning" borderRadius="md" mb={4}>
      <AlertIcon />
      <VStack align="start" spacing={1}>
        <Text fontWeight="bold" fontSize="sm">
          <Trans>Active accredited course found</Trans>
        </Text>
        <Text fontSize="sm">
          <Trans>
            This participant is already enrolled in an active accredited course. The referral will
            be marked as “Pending Review” and reviewed by the Duke support team.
          </Trans>
        </Text>
      </VStack>
    </Alert>
  );
}
